import {
    AsistenciaViajeroIcon,
    AutomotorIcon,
    BiciIcon,
    CandadoIcon,
    HogarIcon,
    MonopatinIcon,
    MotovehiculoIcon,
    NotebookIcon,
    TabletIcon,
} from '../../../assets/products';

export const LANDING_PRODUCTS_CATALOG = [
    {
        id: 'asistencia_viajero',
        name: 'Asistencia al Viajero',
        path: '/asistenciaviajero',
        icon: AsistenciaViajeroIcon
    },
    {
        id: 'vehiculo',
        name: 'Automotor',
        path: '/automotor',
        icon: AutomotorIcon
    },
    {
        id: 'hogar',
        name: 'Hogar',
        path: '/hogar',
        icon: HogarIcon
    },
    {
        id: 'motovehiculo',
        name: 'Motovehículo',
        path: '/motovehículo',
        icon: MotovehiculoIcon
    },
    {
        id: 'notebook',
        name: 'Notebook',
        path: '/notebook',
        icon: NotebookIcon,
        parent: 'microseguros'
    },
    {
        id: 'tablet',
        name: 'Tablet',
        path: '/tablet',
        icon: TabletIcon,
        parent: 'microseguros'
    },
    {
        id: 'monopatin',
        name: 'Monopatín',
        path: '/monopatin',
        icon: MonopatinIcon,
        parent: 'microseguros'
    },
    {
        id: 'bici',
        name: 'Bicicleta',
        path: '/bicicleta',
        icon: BiciIcon,
        parent: 'microseguros'
    },
    {
        id: 'candado',
        name: 'Robos Varios',
        path: '/robosvarios',
        icon: CandadoIcon,
        parent: 'microseguros'
    },
];
